// Helper to generate GA attribute string for navigation links
export function getGaAttribute(prefix, linkText, linkHref, linkPosition) {
    return `${prefix}-$-${linkText}-$-${linkHref ?? ''}-$-${linkPosition}`;
}
//# sourceMappingURL=ga-attribute.js.map